"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import PocCloudTabs from "@/components/pageTabs/pocCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import ImportanceComponent from "./components/importance";

const PerformanceLabsPage = () => {
  return (
    <PageLayout showContactForm>
      <Hero />
      <PocCloudTabs />
      <Intro />
      <FeaturesComponent />
      <ImportanceComponent />
      <Faqs />
    </PageLayout>
  );
};

export default PerformanceLabsPage;
